import {
  getEmailRecommendedInteractiveProductsSchema,
  interactiveCartProductSchema,
} from "@redotech/redo-model/email-product-recommendation";
import * as z from "zod";

export const getEmailInteractiveProductRecommendations = {
  name: "getEmailInteractiveProductRecommendations" as const,
  input: getEmailRecommendedInteractiveProductsSchema,
  output: z.array(interactiveCartProductSchema),
};
